import axios from '../../axios';
import * as types from '../actionTypes';

const fetchThematicsRequest = () => ({type: types.FETCH_THEMATICS_REQUEST});
const fetchThematicsSuccess = thematics => ({type: types.FETCH_THEMATICS_SUCCESS, thematics});
const fetchThematicsFailure = error => ({type: types.FETCH_THEMATICS_FAILURE, error});

export const fetchThematics = query => {
  return dispatch => {
    dispatch(fetchThematicsRequest());
    return axios.get(`/api/list/thematics${query || ''}`).then(
      response => {
        dispatch(fetchThematicsSuccess(response.data));
      },
      error => {
        dispatch(fetchThematicsFailure(error));
      }
    )
  }
};

const fetchCategoriesRequest = () => ({type: types.FETCH_CATEGORIES_REQUEST});
const fetchCategoriesSuccess = categories => ({type: types.FETCH_CATEGORIES_SUCCESS, categories});
const fetchCategoriesFailure = error => ({type: types.FETCH_CATEGORIES_FAILURE, error});

export const fetchCategories = query => {
  return dispatch => {
    dispatch(fetchCategoriesRequest());
    return axios.get(`/api/list/categories${query || ''}`).then(
      response => {
        dispatch(fetchCategoriesSuccess(response.data));
      },
      error => {
        dispatch(fetchCategoriesFailure(error));
      }
    )
  }
};

const fetchMaterialTypesRequest = () => ({type: types.FETCH_MATERIAL_TYPES_REQUEST});
const fetchMaterialTypesSuccess = materialTypes => ({type: types.FETCH_MATERIAL_TYPES_SUCCESS, materialTypes});
const fetchMaterialTypesFailure = error => ({type: types.FETCH_MATERIAL_TYPES_FAILURE, error});

export const fetchMaterialTypes = query => {
  return dispatch => {
    dispatch(fetchMaterialTypesRequest());
    return axios.get(`/api/list/material-types${query || ''}`).then(
      response => {
        dispatch(fetchMaterialTypesSuccess(response.data));
      },
      error => {
        dispatch(fetchMaterialTypesFailure(error));
      }
    )
  }
};